import { AxiosInstance } from "axios";
import MockAdapter from "axios-mock-adapter";

const useMock = (axios: AxiosInstance) => {
	const mock = new MockAdapter(axios);

	mock.onPost("search/").reply(200, {});
	mock.onGet("application").reply(200, {});
};

export default useMock;
